import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducer, { initialState } from './reducer';

export * from './actions';

let preloadedState = {};

/* eslint-disable no-underscore-dangle */
if (typeof window !== 'undefined') {
  preloadedState = window.__PRELOADED_STATE__;
  delete window.__PRELOADED_STATE__;
}
/* eslint-enable no-underscore-dangle */

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducer,
  initialState.merge(preloadedState),
  composeEnhancers(
    applyMiddleware(thunk),
  )
);
export default store;



// WEBPACK FOOTER //
// ./src/state/index.js